import "./TopicTag.css";

function TopicTag({ value = "" }) {
    if (!value) return null;

    return (
        <span className="topic-tag">
            {value.toUpperCase()}
        </span>
    );
}

export default TopicTag;